import { PayloadAction } from '@reduxjs/toolkit';
import { GamePhase, GameplayAnswer, Team } from '../types/GameplayTypes';
import { GameplayQuestion, GameplayState } from './GameplayStore';

export const Assert = {
	condition(state: GameplayState, action: PayloadAction<unknown>, predicate: boolean, message: string) {
		if (!predicate) {
			throw new GameplayError(state, action, message);
		}
	},
	controlTeam(state: GameplayState, action: PayloadAction<unknown>): Team {
		if (state.controllingTeam === undefined) {
			throw new GameplayError(state, action, 'No team has control.');
		}
		return state.controllingTeam;
	},
	faceOffTeam(state: GameplayState, action: PayloadAction<unknown>): Team {
		const team = Assert.controlTeam(state, action);
		Assert.condition(state, action, state.faceOff.previousAttempt?.team !== team, `Face off team ${team} answering twice in a row`);
		return team;
	},
	phase(state: GameplayState, action: PayloadAction<unknown>, phase: GamePhase) {
		if (state.phase !== phase) {
			throw new GameplayError(state, action, `Expected phase ${phase}`);
		}
	},
	question(state: GameplayState, action: PayloadAction<unknown>, round?: number): GameplayQuestion {
		const index = round ?? state.round;
		const question = state.questions[index];
		if (question) {
			return question;
		} else {
			throw new GameplayError(state, action,
				`No question for round ${index}. QuestionSet has ${state.questions.length} rounds.`);
		}
	},
	answer(state: GameplayState, action: PayloadAction<unknown>, answerIndex: number): GameplayAnswer {
		const question = Assert.question(state, action);
		const answer = question.answers[answerIndex];
		if (answer) {
			return answer;
		} else {
			throw new GameplayError(state, action,
				`No answer for index ${answerIndex}. Question has ${question.answers.length} answers.`);
		}
	}
};

export class GameplayError extends Error {
	constructor(state: GameplayState, action: PayloadAction<unknown>, message: string) {
		// Remove 'gameplay/' prefix
		const typeSuffix = action.type.split('/').last();
		super(`Failed to perform action ${typeSuffix} in phase ${state.phase}. ${message}`);
	}
}
